import script from "./LightIDE.vue?vue&type=script&setup=true&lang=js"
export * from "./LightIDE.vue?vue&type=script&setup=true&lang=js"

import "./LightIDE.vue?vue&type=style&index=0&id=0e2edd92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2edd92"]])

export default __exports__